/* Version: 3.5.155 */
'use client';
import styled from 'styled-components';
import { FocusOutline } from '../../mixins/index.js';
import { HEADER_VARIANT } from './constants.js';

// Styled components for UtilityHeader
var Root = /*#__PURE__*/styled.header.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1azf75m-0"
})(["z-index:2;"]);
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : undefined;
var Nav = /*#__PURE__*/styled.nav.withConfig({
  displayName: "styledComponents__Nav",
  componentId: "sc-1azf75m-1"
})(["display:flex;align-items:center;justify-content:flex-end;background-color:", ";margin-left:", ";height:", ";color:", ";"], function (_ref) {
  var theme = _ref.theme,
    variant = _ref.variant,
    useImageAsBackground = _ref.useImageAsBackground;
  if (variant === HEADER_VARIANT.SUB) {
    return theme.utilityHeader.sub.backgroundColor;
  }
  if (useImageAsBackground) {
    return 'transparent';
  }
  return theme.utilityHeader.main.backgroundColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.utilityHeader.marginLeft;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.utilityHeader.height;
}, function (_ref4) {
  var theme = _ref4.theme,
    variant = _ref4.variant;
  return variant === HEADER_VARIANT.MAIN ? theme.utilityHeader.main.color : theme.utilityHeader.sub.color;
});
process.env.NODE_ENV !== "production" ? Nav.displayName = 'Nav' : undefined;
var LogoComponent = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__LogoComponent",
  componentId: "sc-1azf75m-2"
})(["background:transparent;border:none;display:flex;margin-right:auto;margin-left:40px;&:focus-visible{", ";}"], FocusOutline);
process.env.NODE_ENV !== "production" ? LogoComponent.displayName = 'LogoComponent' : undefined;
var HeaderButtons = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__HeaderButtons",
  componentId: "sc-1azf75m-3"
})(["display:flex;align-items:center;height:100%;background-color:", ";color:", ";padding-right:", ";padding-left:", ";padding-bottom:0;padding-top:0;list-style:none;"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.utilityHeader.sub.backgroundColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.utilityHeader.sub.color;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.utilityHeader.paddingRight;
}, function (_ref8) {
  var variant = _ref8.variant;
  return variant === HEADER_VARIANT.MAIN ? '4px' : '0';
});
process.env.NODE_ENV !== "production" ? HeaderButtons.displayName = 'HeaderButtons' : undefined;

export { HeaderButtons, LogoComponent, Nav, Root };
